import React, { forwardRef } from 'react';
import { Input } from 'antd';
import { omit } from 'lodash';

import { SearchNormal1Outline } from 'ui/components/Icon';
import { CaptionWrapperProps, CaptionWrapper } from './CaptionWrapper';

import { CommonSearchProps } from './types';

import { Search as StyledSearch } from './styled';

export type DefaultSearchProps = CommonSearchProps & CaptionWrapperProps;

export const Search = forwardRef<Input, DefaultSearchProps>(
  ({ label, error, caption, ...props }, ref) => (
    <CaptionWrapper label={label} error={error} caption={caption}>
      <StyledSearch ref={ref} $hasError={Boolean(error)} {...omit(props, 'hasError')} />
    </CaptionWrapper>
  ),
);

Search.defaultProps = {
  placeholder: 'Введите запрос',
  allowClear: true,
  prefix: <SearchNormal1Outline />,
};
